/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import classnames from 'classnames'
import moment from 'moment'
import { injectIntl } from 'react-intl'

import { messages } from 'constants/messages'
import christmasImage from 'resources/images/christmas_icon.png'
import logoImage from 'resources/images/logo_appartenances.svg'
import informationImage from 'resources/images/banner_2023.png'
import 'resources/styles/Login.css'

import * as constants from 'constants/Login'

export const MAINTENANCE_LOGIN = false

const message = <p><b>Ligne de conseil et d’assistance : 021 353 53 53</b> - interpretariat@appartenances.ch <br/>
  du lundi au vendredi de 9h à 17h (sauf mardi de 10h à 17h).
</p>

const informationMessage = <div style={{width: '100%', display: 'grid', alignItems: 'center'}}>
  <img
    src={informationImage}
    style={{width: '100%', cursor: 'pointer'}}
    onClick={() => window.open('https://www.appartenances.ch/30-ans-d-appartenances')}
  />
  <a style={{textAlign: 'center'}} href='https://www.appartenances.ch/30-ans-d-appartenances' target="_blank">
  Vers le programme
  </a>
</div>

const extraMessage = <React.Fragment>
  <p><b>Nous avons désormais un nouveau numéro de téléphone, facile à retenir : 021 353 53 53.</b></p>
  <p>L'ancien numéro 021 341 12 51 ne sera plus en service, à partir du 1er janvier 2024.</p>
</React.Fragment>


const christmasMessage = <p>
  Pendant la période de Noël et Nouvel an, les interprètes restent à votre disposition pour des prestations en présence ou à distance, par téléphone ou par vidéo.<br/>
  La ligne de conseil et d’assistance est à votre service, du lundi au vendredi, du 24 au 31 décembre, de 10h à 15h. Elle sera fermée les jours fériés : les 25 décembre, 1er et 2 janvier. Reprise de l'horaire habituel, dès le 5 janvier 2026.<br/>
  Appartenances vous présente ses meilleurs voeux pour les fêtes de fin d'année.
</p>

const easterMessage = <React.Fragment>
  <p>Nos bureaux seront fermés pendant les jours fériés : vendredi 3 et lundi 6 avril 2026. </p>
  <p>Les interprètes restent cependant toujours à votre disposition pour des prestations en présence ou à distance, par téléphone ou par vidéo, y compris pendant ces congés.</p>
  <p>Nous vous souhaitons de belles fêtes de Pâques.</p>
</React.Fragment>

const mayMessage = <React.Fragment>
  <p>En raison des fériés du mois de mai, nos bureaux seront fermés les 14 et 25 mai.</p>
  <p>Les vendredis 1er et 15 mai, notre ligne de conseil et d'assistance vous répondra, de 10h à 15h.</p>
  <p>Les interprètes restent cependant toujours à votre disposition pour des prestations en présence ou à distance, par téléphone ou par vidéo, y compris pendant ces congés.</p>
</React.Fragment>

const summerMessage = <p>
  Les interprètes sont à votre disposition tout l'été pour des prestations en présence ou à distance, par téléphone ou par vidéo.<br/><br/>
  Pendant la fermeture des bureaux d’Appartenances du 21 au 31 juillet, la ligne de conseil et d’assistance restera à votre disposition du lundi au vendredi de 10h à 15h.<br/> Fermé le 1er août. Reprise de nos horaires habituels dès le 4 août 2025.<br/><br/> Nous vous souhaitons une belle période estivale.
</p>

class Login extends React.Component {
  render () {
    const today = moment().format('YYYY-MM-DD')

    const hasInformation = today <= '2023-09-14'
    const hasExtraInformation = false

    const isChristmasPeriod = today >= '2025-12-15' && today < '2026-01-05'
    const isEasterPeriod = today >= '2026-03-30' && today < '2026-04-07'
    const isMayPeriod = today >= '2026-04-24' && today < '2026-05-26'
    const isSummerPeriod = today >= '2025-07-01' && today < '2025-08-04'

    const loginTitle = MAINTENANCE_LOGIN
      ? 'La plateforme est momentanément indisponible pour maintenance. Elle devrait être de nouveau accessible dans quelques instants.'
      : this.props.intl.formatMessage(constants.messages.TITLE)

    return (
      <div className='Container'>
        <div className={classnames('row', 'Container')}>
          <div
            className={classnames('col-md-8 col-xs-12', 'IntroContainer')}
          >
            <img src={logoImage} style={{width: '66%'}} alt=""/>

            <h2 className='AppDescription'>
              {this.props.intl.formatMessage(messages.APP_DESCRIPTION)}
            </h2>

            <div
              style={{
                position: 'absolute',
                bottom: '1%',
                left: 10,
                fontSize:'calc(10px + 0.5vw)'

              }}
            >
              { message }
            </div>
          </div>

          <div className='col-md-4 col-xs-12 FormContainer'>
            <div
              className='row'
              style={{marginRight: 0, marginLeft: 0}}
            >
              <div className='col-md-12 col-xs-6 FormLogin'>
                <h4 className='LoginTitle' style={MAINTENANCE_LOGIN ? {color: 'red'} : undefined}>
                  {loginTitle}
                </h4>

                <div style={{minHeight: 211}}>
                {
                  !MAINTENANCE_LOGIN
                    ?  <React.Fragment>
                      {this.props.children}
                    </React.Fragment>
                    : undefined
                }
                </div>
              </div>

              {
                hasInformation ||
                hasExtraInformation ||
                isChristmasPeriod ||
                isMayPeriod ||
                isSummerPeriod ||
                isEasterPeriod
                  ? <div className='col-md-12 col-xs-6 InformationContainer'>
                    <h4 className='InformationTitle'>
                      {this.props.intl.formatMessage(messages.APP_INFORMATION)}
                    </h4>

                    <div style={{fontSize: 'calc(10px + 0.5vw)'}}>
                      {
                        hasInformation
                          ? informationMessage
                          : undefined
                      }

                      {
                        hasExtraInformation
                          ? extraMessage
                          : undefined
                      }

                      {
                        isChristmasPeriod
                          ? <React.Fragment>
                            {christmasMessage}
                            <div style={{textAlign: 'center'}}>
                              <img
                                src={christmasImage}
                                style={{maxHeight: 120}}
                              />
                            </div>
                          </React.Fragment>
                          : undefined
                      }

                      {
                        isMayPeriod
                          ? mayMessage
                          : undefined
                      }

                      {
                        isSummerPeriod
                          ? summerMessage
                          : undefined
                      }

                      {
                        isEasterPeriod
                          ? easterMessage
                          : undefined
                      }
                    </div>
                  </div>
                  : undefined
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}


export default injectIntl(Login)



// WEBPACK FOOTER //
// ./src/components/authentication/Login.js